import { render, staticRenderFns } from "./ReservationInfo.vue?vue&type=template&id=4218093c&scoped=true&"
import script from "./ReservationInfo.vue?vue&type=script&lang=js&"
export * from "./ReservationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4218093c",
  null
  
)

export default component.exports